import { CLIENT_REVIEWS } from '../../../constants/dashboard';
import DashboardSectionLayout from '../../../layouts/DashboardSectionLayout';
import ReviewCard from '../../CommonComps/Cards/ReviewCard';

const ReviewsHistory = () => {
  // rendering reviews history section component here
  return (
    <DashboardSectionLayout sectionTitle='Reviews History'>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5'>
        {CLIENT_REVIEWS.map((review) => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </div>
    </DashboardSectionLayout>
  );
};

export default ReviewsHistory;
